export default __webpack_public_path__ + "static/media/CrimeCases.c01d0557.png";